import { createSlice } from '@reduxjs/toolkit';
import { sendResetPasswordEmail, resetPassword, handleInvalidToken } from '../thunks/authThunks.js';

const initialState = {
    resetPassword: {
        error: '',
        loading: false,
        success: false,
    },
    createPassword: {
        error: '',
        loading: false,
    },
    loadingSecret: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendResetPasswordEmail.pending, (state) => {
                state.resetPassword.loading = true;
                state.resetPassword.error = '';
                state.resetPassword.success = false;
            })
            .addCase(sendResetPasswordEmail.fulfilled, (state) => {
                state.resetPassword.loading = false;
                state.resetPassword.error = '';
                state.resetPassword.success = true;
            })
            .addCase(sendResetPasswordEmail.rejected, (state, action) => {
                state.resetPassword.loading = false;
                state.resetPassword.error = action.payload || action.error?.message;
                state.resetPassword.success = false;
            })
            .addCase(resetPassword.pending, (state) => {
                state.createPassword.loading = true;
                state.createPassword.error = '';
            })
            .addCase(resetPassword.fulfilled, (state) => {
                state.createPassword.loading = false;
                state.createPassword.error = '';
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.createPassword.loading = false;
                state.createPassword.error = action.payload || action.error?.message;
            })
            .addCase(handleInvalidToken.pending, (state) => {
                state.loadingSecret = true;
            })
            .addCase(handleInvalidToken.fulfilled, (state) => {
                state.loadingSecret = false;
            })
            .addCase(handleInvalidToken.rejected, (state) => {
                state.loadingSecret = false;
            })
            .addDefaultCase((state) => state);
    },
});

export default authSlice.reducer;
